// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file clima.proto (package sextante.clima.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file clima.proto.
 */
export const file_clima: GenFile = /*@__PURE__*/
  fileDesc("CgtjbGltYS5wcm90bxIRc2V4dGFudGUuY2xpbWEudjEiMwofR2V0Q2xpbWFIb3JhcmlvQnlGaW5jYUlkUmVxdWVzdBIQCghmaW5jYV9pZBgBIAEoCSJqChRDbGltYUhvcmFyaW9SZXNwb25zZRIeChZwcm94aW1hX3NpbmNyb25pemFjaW9uGAEgASgJEjIKBWl0ZW1zGAIgAygLMiMuc2V4dGFudGUuY2xpbWEudjEuQ2xpbWFIb3JhcmlvSXRlbSLkAgoQQ2xpbWFIb3JhcmlvSXRlbRINCgVmZWNoYRgBIAEoCRITCgt0ZW1wZXJhdHVyZRgCIAEoARIYChByZWxhdGl2ZWh1bWlkaXR5GAMgASgFEh8KF3NvaWx0ZW1wZXJhdHVyZV8wdG8xMGNtGAQgASgBEhwKFHNvaWxtb2lzdHVyZV8wdG8xMGNtGAUgASgFEhUKDXByZWNpcGl0YXRpb24YBiABKAESIQoZcHJlY2lwaXRhdGlvbl9wcm9iYWJpbGl0eRgHIAEoARIUCgxzdW5zaGluZXRpbWUYCCABKAUSEgoKaXNkYXlsaWdodBgJIAEoBRIXCg90b3RhbGNsb3VkY292ZXIYCiABKAUSEQoJd2luZHNwZWVkGAsgASgBEhUKDXdpbmRkaXJlY3Rpb24YDCABKAUSGgoSZXZhcG90cmFuc3BpcmF0aW9uGA0gASgBEhAKCHJhaW5zcG90GA4gASgJMoIBCgxDbGltYVNlcnZpY2UScgoTR2V0SG9yYXJpb0J5RmluY2FJZBIyLnNleHRhbnRlLmNsaW1hLnYxLkdldENsaW1hSG9yYXJpb0J5RmluY2FJZFJlcXVlc3QaJy5zZXh0YW50ZS5jbGltYS52MS5DbGltYUhvcmFyaW9SZXNwb25zZUILqgIIQXBpLkdycGNiBnByb3RvMw");

/**
 * Finca de la que se pide el clima.
 *
 * @generated from message sextante.clima.v1.GetClimaHorarioByFincaIdRequest
 */
export type GetClimaHorarioByFincaIdRequest = Message<"sextante.clima.v1.GetClimaHorarioByFincaIdRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;
};

/**
 * Describes the message sextante.clima.v1.GetClimaHorarioByFincaIdRequest.
 * Use `create(GetClimaHorarioByFincaIdRequestSchema)` to create a new message.
 */
export const GetClimaHorarioByFincaIdRequestSchema: GenMessage<GetClimaHorarioByFincaIdRequest> = /*@__PURE__*/
  messageDesc(file_clima, 0);

/**
 * Clima hora por hora de la finca.
 *
 * @generated from message sextante.clima.v1.ClimaHorarioResponse
 */
export type ClimaHorarioResponse = Message<"sextante.clima.v1.ClimaHorarioResponse"> & {
  /**
   * yyyy-MM-dd
   *
   * @generated from field: string proxima_sincronizacion = 1;
   */
  proximaSincronizacion: string;

  /**
   * Una entrada por hora, ordenadas por fecha.
   *
   * @generated from field: repeated sextante.clima.v1.ClimaHorarioItem items = 2;
   */
  items: ClimaHorarioItem[];
};

/**
 * Describes the message sextante.clima.v1.ClimaHorarioResponse.
 * Use `create(ClimaHorarioResponseSchema)` to create a new message.
 */
export const ClimaHorarioResponseSchema: GenMessage<ClimaHorarioResponse> = /*@__PURE__*/
  messageDesc(file_clima, 1);

/**
 * Clima de una hora en la finca.
 *
 * @generated from message sextante.clima.v1.ClimaHorarioItem
 */
export type ClimaHorarioItem = Message<"sextante.clima.v1.ClimaHorarioItem"> & {
  /**
   * UTC, ISO 8601
   *
   * @generated from field: string fecha = 1;
   */
  fecha: string;

  /**
   * Temperatura del aire, en grados Celsius.
   *
   * @generated from field: double temperature = 2;
   */
  temperature: number;

  /**
   * Humedad relativa, en porcentaje.
   *
   * @generated from field: int32 relativehumidity = 3;
   */
  relativehumidity: number;

  /**
   * Temperatura del suelo entre 0 y 10 cm, en grados Celsius.
   *
   * @generated from field: double soiltemperature_0to10cm = 4;
   */
  soiltemperature0to10cm: number;

  /**
   * @generated from field: int32 soilmoisture_0to10cm = 5;
   */
  soilmoisture0to10cm: number;

  /**
   * Lluvia de la hora, en mm.
   *
   * @generated from field: double precipitation = 6;
   */
  precipitation: number;

  /**
   * Probabilidad de lluvia, en porcentaje.
   *
   * @generated from field: double precipitation_probability = 7;
   */
  precipitationProbability: number;

  /**
   * Minutos de sol en la hora.
   *
   * @generated from field: int32 sunshinetime = 8;
   */
  sunshinetime: number;

  /**
   * 1 si es de dia, 0 si es de noche.
   *
   * @generated from field: int32 isdaylight = 9;
   */
  isdaylight: number;

  /**
   * Nubosidad total, en porcentaje.
   *
   * @generated from field: int32 totalcloudcover = 10;
   */
  totalcloudcover: number;

  /**
   * Velocidad del viento.
   *
   * @generated from field: double windspeed = 11;
   */
  windspeed: number;

  /**
   * Direccion del viento, en grados.
   *
   * @generated from field: int32 winddirection = 12;
   */
  winddirection: number;

  /**
   * Evapotranspiracion de la hora, en mm.
   *
   * @generated from field: double evapotranspiration = 13;
   */
  evapotranspiration: number;

  /**
   * Mapa de lluvia alrededor de la finca, codificado como lo entrega meteoblue.
   *
   * @generated from field: string rainspot = 14;
   */
  rainspot: string;
};

/**
 * Describes the message sextante.clima.v1.ClimaHorarioItem.
 * Use `create(ClimaHorarioItemSchema)` to create a new message.
 */
export const ClimaHorarioItemSchema: GenMessage<ClimaHorarioItem> = /*@__PURE__*/
  messageDesc(file_clima, 2);

/**
 * Clima de finca de la SPA Cliente. Logica propia del servicio gRPC, sin la capa vieja de servicios. Los
 * datos los trae el worker de clima desde meteoblue. Solo GetHorarioByFincaId: el Cliente
 * (auditado con un subagente) nunca consume el endpoint /semanal, y el /diario ya no existe ni en
 * REST -el cliente arma su propio agregado diario en climaUtils.ts a partir del horario-. Requiere
 * sesion.
 * 
 * SIN DELTA: igual que REST, este dominio no tiene sincronizacion incremental. El propio mensaje
 * trae `proxima_sincronizacion` (unica señal que el cliente realmente usa para decidir cuando volver
 * a pedir, ver FincaClimaServiceBase.ts) — no hay watermark ni tombstones.
 * 
 * Nombres de mensaje con prefijo de dominio: ver terceros_lote.proto para el gotcha real del
 * csharp_namespace compartido — revisar que un nombre no exista ya en otro .proto antes de usarlo.
 * 
 * Pertenencia (2026-09-30): solo trabaja con datos de fincas del cliente de la sesion. Una finca, lote o
 * registro de otro cliente responde NotFound, igual que uno inexistente.
 *
 * @generated from service sextante.clima.v1.ClimaService
 */
export const ClimaService: GenService<{
  /**
   * Clima hora por hora de una finca desde 8 dias antes de hoy, incluido el pronostico, con la fecha estimada
   * de la proxima actualizacion. Sin delta.
   *
   * @generated from rpc sextante.clima.v1.ClimaService.GetHorarioByFincaId
   */
  getHorarioByFincaId: {
    methodKind: "unary";
    input: typeof GetClimaHorarioByFincaIdRequestSchema;
    output: typeof ClimaHorarioResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_clima, 0);

